import React from 'react';
import {Modal, ScrollView, View} from 'react-native';
import Button from '../../../../components/Button';
import Div from '../../../../lib/Div';
import MainStyle from '../../../../../MainStyle';
import {colors} from '../../../../assets/styles/colors';
import {Tournament} from "../../../../../generated/smg_service_pb";
import {isFullSwing} from "../../../../constants";
import P from "../../../../lib/P";

type Props = { tournament?: Tournament, onClose: () => void, onConfirm: () => void, isSponsored: boolean };

const FriendChallengeDetails = (props: Props) => {
  const {tournament, isSponsored} = props;

  return (
    <Modal animationType="fade" transparent visible={!!tournament} statusBarTranslucent={false}
           hardwareAccelerated={false} onRequestClose={props.onClose}>
      <View style={[MainStyle.fix_gradient_and_modal_error_in_landscape, MainStyle.flex1, MainStyle.bg_filter_modal]}>
        <ScrollView contentContainerStyle={MainStyle.flex1}>
          <Div minH="100%" alignItems="center" justifyContent="center">
            <Div w={390} h={452} rounded={20} borderWidth={1} borderColor={colors.settings_border} overflow="hidden"
                 bg={isFullSwing ? '#131314' : colors.settings_bg} py={isFullSwing ? 0 : 43} alignItems="center">
              <P fw="500" fs={26} lh={isFullSwing ? 48 : 26} mb={isFullSwing ? 40 : 21}
                 bg={isFullSwing ? '#252526' : undefined} w="100%" ta="center">
                {isSponsored ? 'Sponsored Tournament Details' : 'Friend Challenge Details'}
              </P>

              <P fw="500" fs={14} mb={3} ta="center">{isSponsored ? 'TOURNAMENT NAME' : 'CREATOR'}</P>

              <P fw="500" fs={24} ta="center" mb={25}>
                {isSponsored ? tournament?.name : tournament?.owner?.username}
              </P>

              <Div row w={331} mb={32}>
                <Div pt={3} borderRightWidth={1} borderRightColor={colors.settings_border} flex={1}>
                  <P fw="500" fs={14} mb={3} ta="center">TOTAL SHOTS</P>
                  <P fw="500" fs={24} ta="center">{tournament?.totalShots}</P>
                </Div>

                <Div pt={3} borderRightWidth={1} borderRightColor={colors.settings_border} flex={1}>
                  <P fw="500" fs={14} mb={3} ta="center">PLAYERS</P>
                  <P fw="500" fs={24} ta="center">1 - {tournament?.maxParticipants}</P>
                </Div>

                <Div pt={3} flex={1}>
                  <P fw="500" fs={14} mb={3} ta="center">ENTRY FEE</P>
                  <P fw="500" fs={24} ta="center" color={isFullSwing ? '#0AF' : colors.newGreenText}>
                    ${(tournament?.entryFee || 0) / 100}
                  </P>
                </Div>
              </Div>

              <Button
                onPress={props.onConfirm} text={`Confirm $${(tournament?.entryFee || 0) / 100} Entry Fee`} w={309}
                fontWeight="600" mb={13} color={isFullSwing ? 'white' : undefined} radius={isFullSwing ? 4 : undefined}
                bg={isFullSwing ? '#3369FF' : undefined}
              />

              <Button
                text="Cancel" w={309} fontWeight="600" borderWidth={1} onPress={props.onClose} color="white"
                borderColor={isFullSwing ? '#4C4C4C' : 'white'} bg={isFullSwing ? '#252526' : colors.mainBackground}
                radius={isFullSwing ? 4 : undefined}
              />
            </Div>
          </Div>
        </ScrollView>
      </View>
    </Modal>
  );
};

export default React.memo(FriendChallengeDetails);
